import { useEffect, useState } from 'react';
import { listarTitulosOcorrenciasAtivo } from '~/Services/Service';

// W-0489 / T13 — Hook de fetch de titulos distintos (Tab Por Titulo, nivel 1).
// LICOES Ciclo 9 L3: pattern `let ativo = true` para evitar race condition
// quando filtro de data muda rapidamente.

const extrairMsg = (err, fallback) =>
  (err && err.message) ? err.message : fallback;

const useTitulosOcorrencia = (dataInicio) => {
  const [estado, setEstado] = useState({
    loading: false,
    items: [],
    erro: null,
  });

  useEffect(() => {
    let ativo = true;
    setEstado((prev) => ({ ...prev, loading: true, erro: null }));
    listarTitulosOcorrenciasAtivo(dataInicio)
      .then((res) => {
        if (!ativo) return;
        setEstado({ loading: false, items: Array.isArray(res) ? res : [], erro: null });
      })
      .catch((err) => {
        if (!ativo) return;
        setEstado({
          loading: false,
          items: [],
          erro: extrairMsg(err, 'Erro ao carregar títulos.'),
        });
      });
    return () => {
      ativo = false;
    };
  }, [dataInicio]);

  return estado;
};

export default useTitulosOcorrencia;
